export const getPutUserRequest = (payload) => {
    return {
      url: "/api/Users",
      method: "PUT",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json"
      },
    };
  };
  
  export const getRequestUsers = () => {
    return {
      url: "/api/Users",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    };
  };

  export const getRequestDeleteUser = (payload) => {
    return {
      url: "/api/Users",
      method: "DELETE",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json"
      },
    };
  };

  export const getRequestConfirmUser = (payload) => {
    return {
      url: `/api/Users/confirm?token=${payload}`,
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      },
    };
  };